<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_pep">
                            <img style="width: 40px; height: 47px;" src="@/assets/question.png" />
                            <h2>PEP - Pessoa Exposta Politicamente </h2>

                            <span>
                                Consideram-se pessoas expostas politicamente (PEP) os ocupantes de cargos e funções públicas listadas nas normas de PLD/FTP editadas pelos órgãos reguladores e fiscalizadores, que desempenham que tenham desempenhado nos últimos cinco ano, no Brasil ou em países, territórios e dependências estrangeiros, cargos, empregos ou funções públicas relevantes, assim como seus representantes, familiares, estreitos colaboradores, e outras pessoas naturais de seu relacionamento próximo, conforme considerado na Resolução CVM nº50/21- Art. 5º e Anexo A e Circular BCB nº 3.978/20, Art. 27º.
                            </span>

                            
                      <div class="buttonsAcoes" style="padding-bottom: 30px;">
                          <button class="btnDefault" style="width: 290px" @click="closeModal">Entendi</button>
                      </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PEP_INFORMATIVO",
            user: 'auth/user',
        }),
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_PEP_INFORMATIVO", false);
            
        },
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_pep{

    margin-top: 30px !important;
    width: 350px !important;
    align-content: center;

    h2{
       margin-bottom: 20px !important;
    }

    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    }


    img{
        margin-left: 42%;
    }

}


.modalpep .modal__wrapper .modal__container.reset {
        width: 400px;
        height: 500px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
